import { Product } from "./product";

// Тип для товара в заказе
interface OrderProduct {
    LineNumber: string;
    Артикул: string;
    НаименованиеПроизводителя: string;
    Номенклатура_Key: string;
    Количество: number;
    Цена: number;
    ТоварНаименование: string;
    Резерв?: number;
    КоличествоПодтверждено?: number;
    КоличествоПришло?: number;
    ЗакупочнаяЦена?: number;
    СуммаВсего?: number;
    МинСрокПоставкиВСтроке?: string;
    СрокПоставкиВСтроке?: string;
    IDСайта?: string;
    ИдентификаторСтроки?: string;
    Отказ?: boolean;
    ПоставщикНаименование?: string;
    Поставщик_Key?: string;
    supplier_id?: string;
    КомментарийКлиента?: string;
    КомментарийМенеджера?: string;
    price_id?: string;
    ВАрхиве?: boolean;
    ДатаСтатуса?: string;
    visible_sup_logo?: string;
  }
  
  // Тип для ответа от 1С
  interface OneCResponse {
    "odata.metadata": string;
    Ref_Key: string;
    Posted: boolean;
    Автор_Key: string;
    DeletionMark: boolean;
    Date: string;
    VINЗапрос: boolean;
    Number: string;
    Банк: string;
    Icq: string;
    Skype: string;
    DataVersion: string;
    customer_id: string;
    VIN: string;
    Email: string;
    БИК: string;
    ВАрхиве: boolean;
    ГрузополучательБИК: string;
    ГрузополучательГород: string;
    ГрузополучательКПП: string;
    ГрузополучательНомерСчета: string;
    ГрузополучательИНН: string;
    ГрузополучательБанк: string;
    Грузополучатель: string;
    ГрузополучательКвартира: string;
    ГрузополучательГородБанка: string;
    ГрузополучательДом: string;
    ГрузополучательКорпус: string;
    ГородБанка: string;
    ВнутреннийЗаказ: boolean;
    ГрузополучательТип: string;
    ГрузополучательРегион: string;
    ГрузополучательСтрана: string;
    ГрузополучательУлица: string;
    ДатаХраненияЗаказаНаСайте: string;
    Контрагент_Key: string;
    Менеджер: string;
    Менеджер_Type: string;
    МаркаАвтомобиля: string;
    ПаспортВыдан: string;
    КонтактныйТелефон: string;
    Индекс: string;
    ИНН: string;
    ОКПО: string;
    Компания: string;
    ДоставкаФамилия: string;
    ДоставкаИмя: string;
    Организация_Key: string;
    Комментарий: string;
    КПП: string;
    МенеджерЗаказа: string;
    МенеджерЗаказа_Type: string;
    Логин: string;
    МодельАвтомобиля: string;
    НомерСчета: string;
    Отчество: string;
    ПаспортДатаВыдачи: string;
    ПаспортКодПодразделения: string;
    ПаспортНомер: string;
    ОГРН: string;
    ПаспортСерия: string;
    НомерЗаказа: string;
    ДоставкаОтчество: string;
    Имя: string;
    ФактКвартира: string;
    Телефон: string;
    ТипЗаказа: string;
    ПровереноVIN: boolean;
    ФактКорпус: string;
    РегионЗаказа_Key: string;
    ТипЦен_Key: string;
    ТипЦенЗакупка_Key: string;
    РучнаяУстановкаСтатусаОплаты: boolean;
    ФактРегион: string;
    ФактУлица: string;
    Фамилия: string;
    ХозОперация: string;
    ЮрГород: string;
    СуммаДокумента: number;
    ФактСтрана: string;
    ЮрДом: string;
    ФактДом: string;
    ЮрКвартира: string;
    СтрокаДатаХраненияЗаказаНаСайте: string;
    ЮрКорпус: string;
    ЮрРегион: string;
    ТипКомпании: string;
    ТипДоставки: string;
    ПодразделениеКомпании_Key: string;
    РаботаетСНДС: boolean;
    ТолькоПросмотрЗаказа: boolean;
    ПорядковыйНомер: string;
    ТочкаДоставки: string;
    ФактГород: string;
    ТипОплаты: string;
    ЮрУлица: string;
    ЮрСтрана: string;
    Товары: OrderProduct[];
    "Автор@navigationLinkUrl": string;
  }
  
  // Основной тип заказа
  interface Order {
    id: number;
    order_number: string;
    status: string;
    customer_name: string;
    customer_phone: string;
    customer_email: string;
    delivery_type: string;
    delivery_point: string;
    total_amount: number;
    products: OrderProduct[];
    one_c_response: OneCResponse;
    one_c_order_id: string;
    warehouse: string;
    storage_until: string;
    created_at: string;
    updated_at: string;
  }
  
  // Тип для массива заказов
  export type OrdersResponse = Order[];


  export interface OrderItem {
  id: number;
  order_id: number;
  product_ref_key: string;
  artikul: string;
  quantity: number;
  created_at: string;
  updated_at: string;
  name: string;
  price: number;
  line_number: number;
  product: Product;
}

  export interface OrderData {
  id: number;
  order_number: string;
  status: string;
  customer_name: string;
  customer_phone: string;
  customer_email: string;
  delivery_type: string;
  delivery_point: string;
  total_amount: string;
  one_c_order_id: string;
  warehouse: string;
  storage_until: string;
  created_at: string;
  updated_at: string;
  items: OrderItem[];
}


  export type OrderResponse = {
    success: boolean;
    data: OrderData; 
  };


export const getOrderStatus = (status: string) => {
    switch (status) {
      case "failed":
        return "При заказе произошла ошибка";
      case "processed":
        return "В обработке";
      case "ГотовКВыдаче":
        return "Ожидает получения";
      case "Отменен":
        return "Отменен";
      case "Выполнен":
        return "Заказ получен";
      case "Новый":
        return "В обработке";
      default:
        return status;
    };
  };